export default "__VITE_ASSET__4447447a__"